// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1H7rl","right":"Footer_right__2loO1","buttons":"Footer_buttons__3KhgJ"};